import { z } from 'zod'

export enum SubscriptionActivationStatus {
  Unavailable = 'unavailable',
  Ready = 'ready',
  PaymentMethodRequired = 'payment_method_required',
  PaymentRequired = 'payment_required',
  Active = 'active',
}

export const SubscriptionActivationConfirmationSchema = z.object({
  subscription_id: z.string(),
  previous_invoice_id: z.string(),
  price_id: z.string(),
  quantity: z.number().int(),
  trial_end: z.number().int(),
  amount_due: z.number().int(),
  currency: z.string(),
})

export const SubscriptionActivationQuoteSchema = SubscriptionActivationConfirmationSchema.extend({
  plan_name: z.string(),
  interval: z.string(),
  interval_count: z.number().int(),
})

export const SubscriptionActivationResponseSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal(SubscriptionActivationStatus.Unavailable), quote: z.null(), payment_url: z.null() }),
  z.object({ status: z.literal(SubscriptionActivationStatus.Active), quote: z.null(), payment_url: z.null() }),
  z.object({ status: z.literal(SubscriptionActivationStatus.Ready), quote: SubscriptionActivationQuoteSchema, payment_url: z.null() }),
  z.object({ status: z.literal(SubscriptionActivationStatus.PaymentMethodRequired), quote: SubscriptionActivationQuoteSchema, payment_url: z.string().url() }),
  z.object({ status: z.literal(SubscriptionActivationStatus.PaymentRequired), quote: SubscriptionActivationQuoteSchema, payment_url: z.string().url() }),
])

export type SubscriptionActivationConfirmation = z.infer<typeof SubscriptionActivationConfirmationSchema>
export type SubscriptionActivationResponse = z.infer<typeof SubscriptionActivationResponseSchema>
